import { useEffect } from 'react';
import { type RouteResource, useResource } from '@atlassian/react-resource-router';

/** Cleans the specific router resource on unmount or key change. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useResourceInvalidate = (resource: RouteResource<any>) => {
	const { clear, key } = useResource(resource);

	useEffect(
		() => () => {
			clear();
		},
		[key, clear],
	);
};
